import styled from 'styled-components';
import { INPUT_HEIGHT, INPUT_ICON_LEFT_PADDING } from '../../Input/constants';
import { height } from '../../style/height';
import { paddingLeft } from '../../style/padding-left';
const FormIconWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  ${paddingLeft(INPUT_ICON_LEFT_PADDING)}
  ${height(INPUT_HEIGHT)}
`;
export default FormIconWrapper;